<script setup lang="ts">
// definePageMeta({
//   bodyClass: 'no-scroll',
// })
useHead({
  htmlAttrs: { class: 'centering43-no-scroll' },
  bodyAttrs: { class: 'centering43-no-scroll' },
  link: [
    {
      rel: 'preload',
      href: '/fonts/UtsukushiFONT.woff2',
      as: 'font',
      type: 'font/woff2',
      crossorigin: 'anonymous',
    },
  ],
})

const gameStateStore = useGameStateStore()
</script>

<template>
  <div
    id="main"
    class="bg-grey-lighten-3"
  >
    <div id="main-content">
      <!-- 通常経路 (definePageMeta) は app.vue が <NuxtLayout><NuxtPage/></NuxtLayout> として
           slot に NuxtPage を渡してくれる。pages 側から <NuxtLayout name="centering43">
           で wrap された場合は親 page の template content が slot に入る -->
      <slot />

      <AppVersion />

      <SessionExpiredDialog />

      <!-- #681: クリスタル化後の Pyxel User Examples 投稿促進ダイアログ。
           cradle → 魔法研究会 への遷移でも消えないよう、グローバル store 駆動で
           レイアウトに 1 つだけマウントする。 -->
      <CradlePyxelUserExamplesDialog />

      <v-snackbar-queue
        v-if="gameStateStore.notificationQueue"
        v-model="gameStateStore.notificationQueue"
        location="left center"
        color="info"
        variant="flat"
        transition="v-slide-x-transition"
        contained
      />
    </div>
  </div>
</template>

<style scoped>
/* 以前は unscoped で `#main { display: flex; align-items: center }` を
   ドキュメント全体に当てており、`/adventurerscamp` 等を経由したあと
   `landing` レイアウトの `<v-main id="main">` までこの flex centering を
   引きずり、`/c/<slug>` のモバイル表示が縦中央に押し下げられていた。
   scoped にして centering43 自身の `#main` だけに閉じ込める。 */
#main {
  background-image: url("@/assets/images/SIZEN17A_33x30a.webp");
  background-position: top center;
  background-repeat: repeat;

  /* height: 100%; */
  min-height: 100vh;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;
}

#main #main-content {
  /* width: 100vw; */
  width: 100%;
  aspect-ratio: 4 / 3;
  /* height: 75vw; */
  max-width: 133.333vh;
  max-height: 100vh;
  /* background-color: lightgray; */
  position: relative; /* v-snackbar-queue contained の基準 */
}
</style>
